module.exports = __webpack_public_path__ + "img/equal-opportunity.0d667623.png";